import axiosClient from 'config/axios';
import tokenConfig from 'config/auth';
import socket from 'config/socket';

import {
  GET_PRODUCTS, ADD_PRODUCT, UPDATE_PRODUCT
} from 'redux/actionTypes';
import { incrementIDGen } from '.';
import { product } from 'constants/idGenType';

export const getProducts = () => (dispatch, getState) => {
  axiosClient
    .get('/api/products', tokenConfig(getState))
    .then(res => {
      dispatch({
        type: GET_PRODUCTS,
        payload: res.data
      });
    })
    .catch(err => console.log(err))
};

export const addProduct = (newProduct, userId) => (dispatch, getState) => {
  axiosClient
    .post('/api/products', newProduct, tokenConfig(getState))
    .then(res => {
      dispatch(incrementIDGen({ id: userId, field: product }));
      dispatch({
        type: ADD_PRODUCT,
        payload: res.data
      });
      // Socket will only emit for admin users.
      socket.emit('broadcast-request', {
        request: 'add-product-broad',
        data: res.data
      });
    })
    .catch(err => console.log(err))
};

// IDGen is not incremented here because only admin can create products.
export const addProductSocket = newProduct => ({
  type: ADD_PRODUCT,
  payload: newProduct
});

export const updateProduct = (updatedProduct) => (dispatch, getState) => {
  axiosClient
    .patch('/api/products', updatedProduct, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: UPDATE_PRODUCT,
        payload: res.data
      });
      // Socket will only emit for admin users.
      socket.emit('broadcast-request', {
        request: 'update-product-broad',
        data: res.data
      });
    })
    .catch(err => console.log(err))
};

export const updateProductSocket = updatedProduct => ({
  type: UPDATE_PRODUCT,
  payload: updatedProduct
});